import { apiClient } from './api';
import type { ProgramDay, ProgramDayNames } from './types';

export class ProgramDayService {
  static async getDayNames(programId: number): Promise<{
    programId: number;
    days: ProgramDay[];
  }> {
    const response = await apiClient.get<{ programId: number; days: ProgramDay[] }>(`/api/training_programs/${programId}/days`);
    return response.data;
  }

  static async getDayName(programId: number, dayNumber: number): Promise<ProgramDay> {
    const response = await apiClient.get<ProgramDay>(`/api/training_programs/${programId}/days/${dayNumber}`);
    return response.data;
  }

  static async updateDayName(
    programId: number,
    dayNumber: number,
    name: string
  ): Promise<ProgramDay> {
    const response = await apiClient.put<ProgramDay>(`/api/training_programs/${programId}/days/${dayNumber}`, {
      name
    });
    return response.data;
  }

  static async deleteDayName(
    programId: number,
    dayNumber: number
  ): Promise<{ message: string; dayNumber: number; defaultName: string }> {
    const response = await apiClient.delete<{ message: string; dayNumber: number; defaultName: string }>(`/api/training_programs/${programId}/days/${dayNumber}`);
    return response.data;
  }

  static async bulkUpdateDayNames(
    programId: number,
    days: { dayNumber: number; name: string }[]
  ): Promise<{ message: string; updatedDays: { dayNumber: number; name: string }[] }> {
    const response = await apiClient.post<{ message: string; updatedDays: { dayNumber: number; name: string }[] }>(`/api/training_programs/${programId}/days/bulk`, {
      days
    });
    return response.data;
  }

  static async updateDayWeekday(
    programId: number,
    dayNumber: number,
    weekday: number | null
  ): Promise<ProgramDay> {
    const response = await apiClient.put<ProgramDay>(`/api/training_programs/${programId}/days/${dayNumber}`, {
      weekday
    });
    return response.data;
  }

  static async updateDay(
    programId: number,
    dayNumber: number,
    payload: { name?: string; weekday?: number | null }
  ): Promise<ProgramDay> {
    const response = await apiClient.put<ProgramDay>(`/api/training_programs/${programId}/days/${dayNumber}`, payload);
    return response.data;
  }

  // Helper method to get day name or default
  static getDayNameOrDefault(dayNumber: number, dayNames?: ProgramDayNames): string {
    if (dayNames && dayNames[dayNumber]) {
      return dayNames[dayNumber];
    }
    return `Day ${dayNumber}`;
  }

  // Helper to convert array of ProgramDay to map
  static convertDaysToMap(days: ProgramDay[]): ProgramDayNames {
    const map: ProgramDayNames = {};
    days.forEach(day => {
      map[day.dayNumber] = day.name;
    });
    return map;
  }
}
